// The one place a pill's colour is decided.
//
// Five private statusBadge()/STATUS_BADGES maps used to live in the document library, the asset
// media panel, the AI indexing panel, the integration activity panel and the integration health
// panel. They overlapped without agreeing — the same "failed" was `text-danger` in one and
// `text-danger-emphasis` in the next — so they are all expressed as tones here instead.
//
// Every tone is a subtle fill with Bootstrap's -emphasis text. Plain `text-warning` on
// `bg-warning-subtle` is #f0a030 on #fcecd6, about 1.8:1, which is why it is not an option.
export const PILL_TONES = {
  // Nothing has happened yet, and nothing is wrong: unassigned, not checked, closed.
  neutral: 'bg-secondary-subtle text-secondary-emphasis',
  // Worth knowing, needs no action: an integration source, an indexed file.
  info: 'bg-info-subtle text-info-emphasis',
  // Underway: assigned, syncing, uploading.
  progress: 'bg-primary-subtle text-primary-emphasis',
  // Finished, healthy, synced.
  success: 'bg-success-subtle text-success-emphasis',
  // Still working, partly.
  warning: 'bg-warning-subtle text-warning-emphasis',
  // Broken; an admin has to act.
  danger: 'bg-danger-subtle text-danger-emphasis',
  // A reference number or an inert fact, which should never read as a state.
  quiet: 'bg-light text-muted',
  // Tags, and only tags. Deliberately the same pair as `progress`: a tag is the one label the
  // admin collects and filters by, so it earns the accent — but a tag is not a state, and a
  // call site asking for `progress` on a label would be saying something it does not mean.
  accent: 'bg-primary-subtle text-primary-emphasis',
};

// Solid fills exist only for markers — the few things whose whole job is to be seen first.
export const MARKER_TONES = {
  danger: 'text-bg-danger',
  warning: 'text-bg-warning',
  primary: 'text-bg-primary',
};

// Colour is not allowed to be the only carrier for the two states that ask an admin to do
// something, so these two tones always bring an icon. Other tones may opt in by passing `icon`.
const TONE_ICONS = {
  warning: 'bi-exclamation-triangle-fill',
  danger: 'bi-x-circle-fill',
};

export const PILL_SIZES = ['inline', 'standalone', 'touch'];

// Which icon a status actually renders. Exported so the rule can be tested as the rule it is,
// rather than by digging the <i> out of the DOM.
export function resolveStatusIcon(tone, icon) {
  return icon || TONE_ICONS[tone];
}
